import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { BaseApiPaging } from "../types";

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string,
): AxiosPromise<BaseApiPaging<AdminUserApi>> => {
  return api.get<BaseApiPaging<AdminUserApi>>(endpoints.ADMIN_USERS.GET(skip, take, searchPhrase, filter));
};

const fetchAdmins = (): AxiosPromise<AdminUserApi[]> => {
  return api.get<AdminUserApi[]>(endpoints.ADMIN_USERS.GET_ADMINS());
};

export const adminUsersApi = {
  fetch,
  fetchAdmins,
};

export interface AdminUserApi {
  id: number;
  firstName: string;
  surname: string;
  email: string;
  phone: string;
  pesel?: string;
  createdDate: Date;
  roles?: RoleApi[];
}

export interface RoleApi {
  id: number;
  name: string;
}
